import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataProductRecall(params) {
	return client.get("api/product-recall/data", {
		params: params,
	});
}

function approveProductRecall (params) {
	return client.post("api/product-recall/approve", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function detailProductRecall (params) {
	return client.get("api/product-recall/detail", {
		params: params,
	});
}

export default {
	getDataProductRecall,
	approveProductRecall,
	detailProductRecall
};